(function () {
  const root = document.querySelector("[data-cart-related]");
  if (!root) return;

  const grid = root.querySelector("[data-cart-related-grid]");
  const loadingEl = root.querySelector("[data-cart-related-loading]");
  const limit = parseInt(root.dataset.limit || "6", 10);

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: Shopify.currency.active })
        .format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2) + " €";
    }
  };

  const fetchJSON = async (url) => {
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  };

  const addToCart = async (variantId) => {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (!res.ok) throw new Error("Add to cart failed");
    return res.json();
  };

  const render = (products) => {
    if (!products.length) {
      grid.innerHTML = "";
      root.style.display = "none";
      return;
    }

    grid.innerHTML = products
      .map((p) => {
        const img = (p.featured_image || p.images?.[0] || "").replace(/^\/\//, "https://");
        const url = p.url || `/products/${p.handle}`;
        const firstAvailableVariant =
          (p.variants || []).find((v) => v.available) || (p.variants || [])[0];

        const disabled = !firstAvailableVariant || !p.available ? "disabled" : "";
        const price = p.price_min != null ? money(p.price_min) : "";

        return `
          <div class="cart-related-products__card">
            <a class="cart-related-products__link" href="${url}">
              ${img ? `<img class="cart-related-products__img" src="${img}" alt="">` : ""}
              <div class="cart-related-products__meta">
                <div class="cart-related-products__name">${p.title}</div>
                <div class="cart-related-products__price">${price}</div>
              </div>
            </a>

            <button
              class="cart-related-products__btn"
              data-add-related
              data-variant-id="${firstAvailableVariant ? firstAvailableVariant.id : ""}"
              ${disabled}
              type="button"
            >
              Ajouter
            </button>
          </div>
        `;
      })
      .join("");
  };

  const init = async () => {
    try {
      // 1) panier
      const cart = await fetchJSON("/cart.js");
      const items = cart.items || [];
      if (!items.length) {
        root.style.display = "none";
        return;
      }

      // ids produits déjà dans le panier (pour filtrer)
      const inCartProductIds = new Set(items.map((it) => it.product_id));

      // 2) produit "ancre" (dernier item)
      const anchor = items[items.length - 1];
      const anchorProductId = anchor.product_id;

      // 3) recommandations
      const rec = await fetchJSON(
        `/recommendations/products.json?product_id=${anchorProductId}&limit=${limit + 6}&intent=related`
      );

      const products = (rec.products || [])
        .filter((p) => !inCartProductIds.has(p.id)) // exclure déjà au panier
        .filter((p) => p.available) // uniquement dispo
        .slice(0, limit);

      if (loadingEl) loadingEl.remove();
      render(products);
    } catch (e) {
      // en cas d’erreur, on masque le bloc (propre)
      root.style.display = "none";
      // console optionnel
      // console.warn("Cart related products error:", e);
    }
  };

  // add-to-cart handler
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-add-related]");
    if (!btn) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    const old = btn.textContent;
    btn.textContent = "Ajout…";

    try {
      await addToCart(parseInt(variantId, 10));

      btn.textContent = "Ajouté ✓";

      // IMPORTANT : selon ton thème, il faut déclencher un refresh du drawer / cart UI.
      // Dawn-like : on déclenche un event générique souvent écouté.
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:updated"));

      setTimeout(() => {
        btn.textContent = old;
        btn.disabled = false;
      }, 1200);
    } catch (e2) {
      btn.textContent = "Erreur";
      setTimeout(() => {
        btn.textContent = old;
        btn.disabled = false;
      }, 1200);
    }
  });

  init();
})();
